import { CLoadingButton } from './CLoadingButton.js';

const CLoadingButtonPlugin = {
    install: (app) => {
        app.component(CLoadingButton.name, CLoadingButton);
    },
};

export { CLoadingButton, CLoadingButtonPlugin };
//# sourceMappingURL=index.js.map
